import { axiosJWT } from 'modules/axios'
import { APP_CONFIG } from 'services/app-config'

export function getPond(orderId) {
  return axiosJWT({
    method: 'GET',
    url: `${APP_CONFIG.care_cluster}/orders/${orderId}/pond`,
  }).then(resp => resp.data)
}
